import * as React from "react";
import * as Scrivito from "scrivito";
import { getPageLink } from "utils";
import { useTranslate } from "hooks";
import { Icon } from "../../components";

import "./TextMediaWidget.scss";

const MoreTextLinkComponent = Scrivito.connect(({ widget }) => {
  const translate = useTranslate();
  const [isComplementaryTextShown, toggleComplementaryTextShown] =
    React.useState(false);

  const toggleComplementaryText = () =>
    toggleComplementaryTextShown(!isComplementaryTextShown);

  const links = widget.get("links") || [];
  const contactPerson = widget.get("contactPerson");

  return (
    <React.Fragment>
      {links.length > 0 && <ComplementaryText widget={widget} />}
      {widget.get("complementaryText") && isComplementaryTextShown && (
        <ComplementaryText widget={widget} />
      )}
      {links.length === 0 && widget.get("complementaryText") && (
        <Button
          isComplementaryTextShown={isComplementaryTextShown}
          toggleComplementaryText={toggleComplementaryText}
          buttonTextLess={translate("TEXT_LESS_TEXT")}
          buttonTextMore={translate("TEXT_MORE_TEXT")}
        />
      )}
      {links.length > 0 && (
        <LinkList links={links} linkMore={translate("TEXT_READ_MORE")} />
      )}
      {contactPerson && <ContactPerson widget={widget} />}
    </React.Fragment>
  );
});

const Button = ({
  isComplementaryTextShown,
  toggleComplementaryText,
  buttonTextLess,
  buttonTextMore,
}) => {
  if (isComplementaryTextShown) {
    return (
      <button
        className="button button-upload button-toggle"
        onClick={toggleComplementaryText}
      >
        {buttonTextLess}
        <Icon iconName="circle-chevron-up" prefix="fa-regular" />
      </button>
    );
  }
  return (
    <button
      className="button button-download button-toggle"
      onClick={toggleComplementaryText}
      data-testid="showMoreBtn"
    >
      {buttonTextMore}
      <Icon iconName="circle-chevron-down" prefix="fa-regular" />
    </button>
  );
};

const LinkList = ({ links, linkMore }) => (
  <p>
    {links.map((link, idx) => (
      <Scrivito.LinkTag
        key={`moreText-link-${(link, idx)}`}
        to={getPageLink(link)}
        className="button button-linklist"
      >
        {link.title() ? link.title() : linkMore}
      </Scrivito.LinkTag>
    ))}
  </p>
);

const ComplementaryText = ({ widget }) => (
  <Scrivito.ContentTag
    tag="div"
    content={widget}
    attribute="complementaryText"
    className="complementary-text"
  />
);

const ContactPerson = ({ widget }) => {
  const contactPerson = widget.get("contactPerson");
  const contactPersonIcon = widget.get("showContactIcon");
  const textContact = widget.get("contactFormLinkTxt");
  const textImgAlt = widget.get("contactIconAltTxt");

  return (
    <p>
      <Scrivito.LinkTag
        to={getPageLink(contactPerson)}
        className="button button-link"
      >
        {textContact}
      </Scrivito.LinkTag>
      {contactPersonIcon && (
        <img
          src={"src/assets/images/Kontaktbutton_Final.png"}
          className="contact-modal-button"
          alt={textImgAlt}
        />
      )}
    </p>
  );
};

export default MoreTextLinkComponent;
